module.exports = __webpack_public_path__ + "images/f6d59216fa886f54da86c2ab6e8277fd.svg";